/**
 * @tabler/icons-react v2.22.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLasso = createReactComponent("lasso", "IconLasso", [
  [
    "path",
    {
      d: "M4.028 13.252c-.657 -.972 -1.028 -2.078 -1.028 -3.252c0 -3.866 4.03 -7 9 -7s9 3.134 9 7s-4.03 7 -9 7c-1.913 0 -3.686 -.464 -5.144 -1.255",
      key: "svg-0"
    }
  ],
  ["path", { d: "M5 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-1" }],
  ["path", { d: "M5 17c0 1.42 .316 2.805 1 4", key: "svg-2" }]
]);

export { IconLasso as default };
//# sourceMappingURL=IconLasso.js.map
